const Aboutd = [{
    id : 1,
    que : "Name",
    ans : "Hamza",
},
{
    id : 2,
    que : "Age",
    ans : "18",
},
{
    id : 3,
    que : "Education (Studing)",
    ans : "BSCS",
},
{
    id : 4,
    que : "Location",
    ans : "Lahore,PK",
},

{
    id : 5,
    que : "Total Projects",
    ans : "35+",
},
{
    id : 6,
    que : "Professional Experience",
    ans : "2 Years +",
},
{
    id : 7,
    que : "Remote Experience",
    ans : "9 Months +",
},
{
    id : 8,
    que : "English",
    ans : "Fluent",
},
{
    id : 9,
    ans : "HTML",
},
{
    id : 10,
    ans : "CSS",
},
{
    id : 11,
    ans : "JavaScript",
},
{
    id : 12,
    que : "Library",
    ans : "React.js",
},
{
    id : 13,
    que : "Framework",
    ans : "Bootstrap",
},
{
    id : 14,
    que : "JS Library",
    ans : "jQuery",
},

{
    id : 15,
    que : "CSS Preprocessor",
    ans : "SASS",
},
{
    id : 16,
    que : "Pakage Manager",
    ans : "NPM",
},
{
    id : 17,
    que : "Components Library",
    ans : "Material UI",
},
{
    id : 18,
    que : "State Container",
    ans : "Redux.js",
},
{
    id : 19,
    que : "CMS",
    ans : "Wordpress",
},
{
    id : 20,
    que : "Backend",
    ans : "PHP",
},

]
export default Aboutd;


